define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/xml",
	"csi/xml/Query",
	"SiteAdmin/DataSheetTable"
], function(declare, _, csi, xml, Query, DataSheetTable) {

	return declare(DataSheetTable, {
		/** @property {reflist} activeProductSalesRegions - product sales regions to use to filter list of Items to display. Default empty = All will be displayed */
		activeProductSalesRegions: null,

		/**
		 * @param {Query} q
		 * Add filter if specified in page location
		 */
		_addProductSalesRegionQuery: function(q) {
			var activeProductSalesRegions = this.activeProductSalesRegions;

			if (!_.isEmpty(activeProductSalesRegions)) {
				var cache = this.getCache();
				var salesRegions = activeProductSalesRegions;

				_.each(activeProductSalesRegions, function(activeProductSalesRegion) {
					var activeProductSalesRegionNode = cache.getNode(activeProductSalesRegion);
					if (activeProductSalesRegionNode?.SecondaryProductSalesRegions) {
						salesRegions = salesRegions.concat(activeProductSalesRegionNode.SecondaryProductSalesRegions);
					}
				});

				_.each(salesRegions, function(region) {
					this.RefAttr("OnlyForProductSalesRegions", xml.OP_EQUALS, region)
						.RefAttr("OnlyForProductSalesRegions", xml.OP_NULL);
				}, q.Or());
			}
		},

		/**
		 * @override
		 * Filter out Items that do not apply to selected product sales region
		 */
		onBuildColumns: function(ctx, dfds) {
			const store = this.get("store");
			if (!store) {
				return;
			}

			const q = store.filterQuery || new Query();

			// filter out Items that do not apply to selected product sales region
			this._addProductSalesRegionQuery(q);

			if (!q.isEmpty()) {
				store.filterQuery = q;
			}
		},

		/**
		 * @override
		 * Update list of selected ProductSalesRegions
		 */
		onViewCreate: function() {
			this.watch("activeProductSalesRegions", (name, oldValue, newValue) => {
				this.activeProductSalesRegions = newValue;
			});
			this.inherited(arguments);
		}

	});
});